// src/seo/AboutSEO.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

export default function AboutSEO() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": "Madeshwara Ambulance Services",
    "url": "https://madeshwaraambulance.com/about",
    "logo": "https://madeshwaraambulance.com/assets/logo.png",
    "description": "About Madeshwara Ambulance: dedicated to 24/7 emergency and patient transport services in Bangalore and Karnataka.",
    "telephone": "+91 98459 74238",
    "email": "madeshwaraa@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "No.9/8, Near Swimming Pool, 1st Main Road, 1st Block East, Byrasandra, Jayanagar-560011",
      "addressLocality": "Bangalore",
      "addressRegion": "Karnataka",
      "postalCode": "560011",
      "addressCountry": "IN"
    },
    "sameAs": [
      "https://www.facebook.com/MadeshwaraAmbulance",
      "https://www.instagram.com/MadeshwaraAmbulance",
      "https://www.linkedin.com/company/madeshwara-ambulance"
    ]
  };

  return (
    <Helmet>
      <title>About Madeshwara Ambulance | Trusted Emergency Care in Bangalore</title>
      <meta name="description" content="Learn about Madeshwara Ambulance, providing fast and reliable emergency medical transport across Bangalore and Karnataka." />
      <meta name="keywords" content="Madeshwara ambulance, ambulance company in Bangalore, emergency medical transport, patient transport service" />
      <meta property="og:title" content="About Madeshwara Ambulance | Trusted Emergency Care in Bangalore" />
      <meta property="og:description" content="Learn about our mission, services, and dedicated ambulance teams serving Bangalore and Karnataka 24/7." />
      <meta property="og:image" content="/assets/about-og.jpg" />
      <meta property="og:url" content="https://madeshwaraambulance.com/about" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="About Madeshwara Ambulance | Trusted Emergency Care in Bangalore" />
      <meta name="twitter:description" content="Discover our story and dedication to providing fast, reliable ambulance services in Bangalore." />
      <meta name="twitter:image" content="/assets/about-og.jpg" />
      <link rel="canonical" href="https://madeshwaraambulance.com/about" />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
